import { createSelector } from '@reduxjs/toolkit'

export const makeSelectorById = () => createSelector(
  (state) => state.category,
  (_, id) => id,
  (slice, id) => {
    return slice.items?.find(({ id: _id }) => _id === Number(id))
  }
)

export const makeSelectorCategory = () => createSelector(
  (state) => state.category,
  (slice) => {
    return slice.items || []
  }
)

export const makeSelectorSelectedItemId = () => createSelector(
  (state) => state.category,
  (slice) => {
    return slice.selectedItemId
  }
)

export const makeSelectorByDepartmentId = () => createSelector(
  (state) => state.category,
  (_, id) => id,
  (slice, id) => {
    return slice.items?.filter(({ collection_id: _id }) => _id === Number(id))
  }
)

export const makeSelectorBySharepointStatus = () => createSelector(
  (state) => state.category,
  (_, id) => id,
  (slice, id) => {
    const item = slice.items.find((item) => item.id === Number(id))
    return item && item.sharepoint_status
  }
)

export const makeSelectorBySharepointUrl = () => createSelector(
  (state) => state.category,
  (_, id) => id,
  (slice, id) => {
    const item = slice.items.find((item) => item.id === Number(id))
    return item && item.url
  }
)
